import React, { Fragment, memo } from 'react'
import { Box, Typography, Link } from '@material-ui/core'

import { useTranslation } from 'react-i18next'

import constants from 'constants/index'
import styles from '../styles'

const DisableBrowserCookies = () => {
  const { t } = useTranslation()
  const classes = styles()

  const previewTexts = {
    title: t('menu.disableCookies.title'),
    description: t('menu.disableCookies.description'),
    stepLabel: t('menu.disableCookies.stepLabel'),
  }

  const getStepText = (stepKey) => t(`menu.disableCookies.steps.${stepKey}`)

  return (
    <Box textAlign="justify" display="flex" flexDirection="column">
      <Typography variant="h6" gutterBottom className={classes.title}>
        {previewTexts?.title}
      </Typography>
      <Typography variant="body1" gutterBottom className={classes.description}>
        {previewTexts?.description}
      </Typography>
      <Typography>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            <span className={classes.span}>{previewTexts?.stepLabel} 1</span>
            &nbsp;-&nbsp;
            {getStepText('zero')}{' '}
            {constants.cookies.disableCookies.DISABLE_COOKIES_LINKS_FROM_STEP_1.map(
              (link) => (
                <Fragment key={link.url}>
                  <Link
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    className={classes.link}
                  >
                    {link.name}
                  </Link>
                  ,&nbsp;
                </Fragment>
              ),
            )}{' '}
            {getStepText('one')}
          </li>
          {constants.cookies.disableCookies.DISABLE_COOKIES_STEPS.map(
            (item) => (
              <li key={item.step} className={classes.listItem}>
                <span className={classes.span}>
                  {previewTexts?.stepLabel} {item.step}
                </span>
                &nbsp;- {getStepText(item.stepKey)}
              </li>
            ),
          )}
        </ul>
      </Typography>
    </Box>
  )
}

export default memo(DisableBrowserCookies)
